export default {"src":"/_next/static/media/Warning.8f731a5f.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};